import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'

export default function ContentBlocks1({ data }) {
    const { contentBlocks1Block1Text, contentBlocks1Block1Title, contentBlocks1Block2Title, contentBlocks1Block2Text, contentBlocks1Block1Icon, contentBlocks1Block2Icon } = data
    return (
        <div className='about-mission-wrap'>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='abt-mission-col'>
                            <figure>
                                <GatsbyImage
                                    image={getImage(contentBlocks1Block1Icon?.localFile)}
                                    alt='image'
                                />
                            </figure>
                            <h2 className='heading-level-2 black-color'>
                                {contentBlocks1Block1Title && parser(contentBlocks1Block1Title)}
                            </h2>
                            <p>{contentBlocks1Block1Text && parser(contentBlocks1Block1Text)}</p>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='abt-vision-col'>
                            <figure>
                                <GatsbyImage
                                    image={getImage(contentBlocks1Block2Icon?.localFile)}
                                    alt='image'
                                />
                            </figure>
                            <h2 className='heading-level-2 black-color'>{contentBlocks1Block2Title && parser(contentBlocks1Block2Title)}</h2>
                            <p>{contentBlocks1Block2Text && parser(contentBlocks1Block2Text)}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
